export default __webpack_public_path__ + "static/media/settings-icon.850197a8.svg";